import { getActiveRoleRequestHeaders } from "@/lib/utils/api/active-role-header";
import { getEffectiveTenantApiHeaders } from "@/lib/utils/env/effective-tenant";
import { resolveOpenApiBasePath } from "@/lib/utils/api/openapi-configuration";

export type StaffReviewPresenceResource =
  | { kind: "class-enrollment"; id: number }
  | { kind: "time-entry"; id: string }
  | { kind: "makeup-session"; id: string };

function presenceUrl(resource: StaffReviewPresenceResource): string {
  const baseUrl = resolveOpenApiBasePath();
  const encoded =
    resource.kind === "class-enrollment"
      ? encodeURIComponent(String(resource.id))
      : encodeURIComponent(resource.id);

  switch (resource.kind) {
    case "class-enrollment":
      return `${baseUrl}/api/class-enrollments/${encoded}/review-presence`;
    case "time-entry":
      return `${baseUrl}/api/time-entries/${encoded}/review-presence`;
    case "makeup-session":
      return `${baseUrl}/api/makeup-sessions/${encoded}/review-presence`;
  }
}

export async function upsertStaffReviewPresence(
  accessToken: string,
  resource: StaffReviewPresenceResource,
): Promise<boolean> {
  const response = await fetch(presenceUrl(resource), {
    method: "PUT",
    headers: {
      ...getEffectiveTenantApiHeaders(),
      ...getActiveRoleRequestHeaders(),
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (response.status === 404) return false;
  return response.ok;
}

export async function clearStaffReviewPresence(
  accessToken: string,
  resource: StaffReviewPresenceResource,
): Promise<void> {
  const response = await fetch(presenceUrl(resource), {
    method: "DELETE",
    headers: {
      ...getEffectiveTenantApiHeaders(),
      ...getActiveRoleRequestHeaders(),
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (response.status === 404 || response.status === 204) return;
}
